import { FCC } from "types";

export const TableControlGroup: FCC = ({ children }) => {
  return <div className="table-control-group">{children}</div>;
};
